import { get, post, del, put } from './api/http.service';
import store from '@/store';
/**
 * create video clip - ビデオクリップを作成する
 */
export const createVideoClip = (data) => {
  return post('/ccs/v1/media/videoclip', data);
};

/**
 * get video clips - ビデオクリップを取得する
 */
export const getVideoClips = (params) => {
  return get(`/ccs/v1/media/videoclip`, params);
};

/**
 * delete video clips - ビデオクリップを削除する
 */
export const deleteVideoClips = (params) => {
  return del('/ccs/v1/media/videoclip', params);
};

export const downloadVideoClips = (clipIds) => {
  return get(`/ccs/v1/media/videoclip/download?ids=${clipIds}`);
};

export const playVideoClips = (params) => {
  return get('/ccs/v1/media/videoclip/play', params);
};

export const setVideoClip = (data) => {
  store.dispatch('video/changeVideoClip', data);
};

// Get video clip tags
export const getClipTags = (params) => {
  return get('/ccs/v1/media/videoclip/tag', params);
};

// Create a clip tag
export const createClipTag = (payload) => {
  return post('/ccs/v1/media/videoclip/tag', payload);
};

// Update a clip tag
export const updateClipTag = (payload) => {
  return put('/ccs/v1/media/videoclip/tag', payload);
};
// Delete a clip tag
export const deleteClipTag = (payload) => {
  return del('/ccs/v1/media/videoclip/tag', payload);
};

// Update clip
export const updateVideoClip = (payload) => {
  return put('/ccs/v1/media/videoclip', payload);
};
